import runPdfJob from './runPdfJob';

const extractPDFText = async (key) => {
  try {
    const result = await runPdfJob({
      key,
      startPath: '/extract',
      resultPath: '/extract-result',
      timeout: 5 * 60 * 1000,
      label: 'text extraction',
    });

    return result;
  } catch (err) {
    console.log(err);
  }

  return null;
};

export default extractPDFText;
